import classnames from 'classnames';
import React from 'react';
import styles from './wizardStepsNav.module.scss';

interface WizardStepsNavProps {
  currentStep?: number;
  totalSteps?: number;
  stepNames: string[];
}

const WizardStepsNav = ({
  currentStep = 0,
  totalSteps = 0,
  stepNames,
}: WizardStepsNavProps) => {
  const steps = Array.from({ length: totalSteps });
  return (
    <>
      <div className={classnames(styles.mobileStepNavContainer)}>
        <div
          key={currentStep}
          className={classnames(
            'rounded-circle',
            'd-flex align-items-center justify-content-center',
            'bg-primary text-white',
            styles.mobileNavStepIndicator
          )}
        >
          {currentStep}
        </div>
        <p className={classnames('text-primary-dark', styles.mobileStepName)}>
          {stepNames[currentStep - 1]}
        </p>
      </div>

      <div
        className={classnames(
          'position-relative',
          'mx-auto',
          'mt-4',
          styles.stepsNavContainer
        )}
      >
        {steps.map((_, index) => {
          const stepNameX = `stepName${index + 1}`;
          const widthPerc = 100 / (steps.length - 1);
          return (
            <React.Fragment key={index}>
              <div
                key={index}
                className={classnames(
                  'rounded-circle',
                  'd-flex align-items-center justify-content-center',
                  styles.navStepIndicator,
                  {
                    'bg-primary text-white': index + 1 <= currentStep,
                    'text-primary bg-secondary': index + 1 > currentStep,
                  }
                )}
              >
                {index + 1}
                <p
                  className={classnames('text-primary-dark', styles.stepName, {
                    [styles[stepNameX]]: index + 1 === 2 || index + 1 === 3,
                  })}
                >
                  {stepNames[index]}
                </p>
              </div>

              {index < steps.length - 1 ? (
                <hr
                  className={classnames(styles.stepsLine, {
                    'border-primary': index + 1 < currentStep,
                    'border-secondary': index + 1 >= currentStep,
                  })}
                  style={{
                    width: `${widthPerc}%`,
                    left: `${index * (widthPerc - 1)}%`,
                  }}
                />
              ) : null}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default WizardStepsNav;
